import * as tokenService from "@service/tokenService";

function clearStorage(storage) {
  try {
    storage?.clear();
  } catch (error) {
    console.warn("Failed to clear browser storage.", error);
  }
}

async function clearCacheStorage() {
  if (typeof window === "undefined" || !("caches" in window)) {
    return;
  }

  try {
    const cacheKeys = await window.caches.keys();
    await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
  } catch (error) {
    console.warn("Failed to clear Cache Storage.", error);
  }
}

async function clearIndexedDb() {
  if (
    typeof window === "undefined" ||
    !("indexedDB" in window) ||
    typeof window.indexedDB.databases !== "function"
  ) {
    return;
  }

  try {
    const databases = await window.indexedDB.databases();
    const deletions = databases
      .filter((database) => Boolean(database?.name))
      .map(
        (database) =>
          new Promise((resolve) => {
            const request = window.indexedDB.deleteDatabase(database.name);

            request.onsuccess = () => resolve();
            request.onerror = () => resolve();
            request.onblocked = () => resolve();
          })
      );

    await Promise.all(deletions);
  } catch (error) {
    console.warn("Failed to clear IndexedDB.", error);
  }
}

export async function clearClientPersistence() {
  tokenService.removeToken();

  if (typeof window === "undefined") {
    return;
  }

  clearStorage(window.localStorage);
  clearStorage(window.sessionStorage);

  await Promise.all([clearCacheStorage(), clearIndexedDb()]);
}
